import React, { useState } from 'react'
import classNames from 'classnames'
import Arrowleft from '../assets/svg/arrow-left-01.svg'

export default function AppMessages({
  isOpen,
  onClose,
  messages,
  closeOnOverlayClick = true,
}) {
  // Hooks MUST always run
  const [view, setView] = useState('list') 
  const [selectedMessage, setSelectedMessage] = useState(null)

  const openMessage = (message) => {
    setSelectedMessage(message)
    setView('detail')
  }

  const handleClose = () => {
    setView('list')
    setSelectedMessage(null)
    onClose()
  }

  return (
    <>
      {/* Overlay */}
      <div
        className={classNames(
          'fixed inset-0 bg-black/40 z-40 transition-opacity',
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={() => {
          if (closeOnOverlayClick) handleClose()
        }}
      />

      {/* Sliding Panel */}
      <aside
        className={classNames(
          'fixed top-[70px] right-0 w-[500px] bg-white z-50',
          'transform transition-transform duration-300 ease-in-out',
          isOpen ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        {/* Header */}
        <header className='flex items-center justify-between py-3 px-4 border-b'>
          <div className='flex items-center gap-2'>
            {view === 'detail' && (
              <button onClick={() => setView('list')} className='text-lg'>
                <img src={Arrowleft} alt='centelHr' />
              </button>
            )}
            <h2 className='font-semibold text-base text-black'>
              {view === 'list' ? 'CentelHR Messages' : 'Message'}
            </h2>
          </div>

          <button onClick={handleClose} className='text-lg'>
            ✕
          </button>
        </header>

        {/* Content */}
        <main className='overflow-y-auto h-[400px] mb-2'>
          {view === 'list' && (
            <div className='px-4 py-2 '>
              {messages.map((message) => (
                <div
                  key={message.id}
                  className='border rounded p-2 mb-2 cursor-pointer hover:bg-gray-50'
                  onClick={() => openMessage(message)}
                >
                  <h4 className='font-semibold text-sm text-black truncate'>
                    {message.title}
                  </h4>
                  <p className='text-sm font-medium text-gray-600 truncate'>
                    {message.body}
                  </p>
                  <span className='text-xs font-semibold text-gray-400'>
                    {message.timestamp}
                  </span>
                </div>
              ))}
            </div>
          )}

          {view === 'detail' && selectedMessage && (
            <div className='p-4 '>
              <h3 className='font-semibold text-sm'>{selectedMessage.title}</h3>
              <p className='text-gray-700 font-medium text-sm whitespace-pre-line'>
                {selectedMessage.body}
              </p>
              <div className='mt-6 text-xs font-semibold text-black'>
                {selectedMessage.timestamp}
              </div>
            </div>
          )}
        </main>
      </aside>
    </>
  )
}
